export default __webpack_public_path__ + "static/media/play.18632a65.svg";